import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { UserReportedUser } from '../modal';

export default function reducer(state: UserReportedUser = new UserReportedUser(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.USER_REPORT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.USER_REPORT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.USER_REPORT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
